import { Main } from "./Main";
import { Global } from './data/Global';
import "./ui/controlWC/.main";
import '/style/base.scss';

Main._Iniciar();

const v = `${Global._APP_VERSION_NAME}/${Global._APP_VERSION_BUILD}`
console.warn("version: %c" + v, "background-color: #d30c7b; color: #FFF;");